module.exports = __webpack_public_path__ + "img/organ-title.63f71363.png";